import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  Typography,
  Paper,
  Grid,
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";
import {
  Close as CloseIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import axios from "axios";
import { BASE_URL } from "../../../services/configUrls";

const ViewMembershipModal = ({ open, onClose, instituteId }) => {
  const [loading, setLoading] = useState(false);
  const [membershipData, setMembershipData] = useState(null);
  const [selectedFeatures, setSelectedFeatures] = useState(null);
  const [featuresDialogOpen, setFeaturesDialogOpen] = useState(false);

  useEffect(() => {
    if (open && instituteId) {
      fetchMembershipDetails();
    }
  }, [open, instituteId]);

  const fetchMembershipDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/accounts/institute/${instituteId}/membership-details`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      setMembershipData(response.data);
    } catch (error) {
      console.error("Error fetching membership details:", error);
      setMembershipData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
    setFeaturesDialogOpen(false);
    setSelectedFeatures(null);
  };

  const handleViewFeatures = (features) => {
    setSelectedFeatures(features);
    setFeaturesDialogOpen(true);
  };

  const handleCloseFeaturesDialog = () => {
    setFeaturesDialogOpen(false);
    setSelectedFeatures(null);
  };

  const renderFeatureValue = (feature) => {
    if (feature.type === "Text") {
      return feature.symbol
        ? `${feature.symbol} ${feature.value_text}`
        : feature.value_text;
    } else if (feature.type === "Count") {
      return feature.value_count;
    }
    return "-";
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            maxHeight: "85vh",
            width: "1200px",
            maxWidth: "95vw",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E5E7EB",
            pb: 2,
            pt: 2.5,
            px: 3,
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              color: "#1F1F1F",
            }}
          >
            Membership Details
          </Typography>
          <IconButton
            onClick={handleClose}
            size="small"
            sx={{
              color: "#6B7280",
              "&:hover": {
                backgroundColor: "#F3F4F6",
              },
            }}
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "300px",
              }}
            >
              <CircularProgress size={40} />
            </Box>
          ) : membershipData ? (
            <Box>
              {/* Membership History Section */}
              {membershipData.membership_history &&
                membershipData.membership_history.length > 0 && (
                  <Paper
                    elevation={0}
                    sx={{
                      border: "1px solid #E5E7EB",
                      borderRadius: "6px",
                      p: 3,
                      mt: 2,
                    }}
                  >
                    {/* <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#374151",
                        mb: 2.5,
                      }}
                    >
                      Membership History
                    </Typography> */}
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#6B7280",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                backgroundColor: "#F9FAFB",
                                borderBottom: "2px solid #E5E7EB",
                              }}
                            >
                              Renewal
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#6B7280",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                backgroundColor: "#F9FAFB",
                                borderBottom: "2px solid #E5E7EB",
                              }}
                            >
                              Membership Name
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#6B7280",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                backgroundColor: "#F9FAFB",
                                borderBottom: "2px solid #E5E7EB",
                              }}
                            >
                              Signup
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#6B7280",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                backgroundColor: "#F9FAFB",
                                borderBottom: "2px solid #E5E7EB",
                              }}
                            >
                              Renewal
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#6B7280",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                backgroundColor: "#F9FAFB",
                                borderBottom: "2px solid #E5E7EB",
                              }}
                            >
                              Valid Till
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#6B7280",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                backgroundColor: "#F9FAFB",
                                borderBottom: "2px solid #E5E7EB",
                              }}
                            >
                              Status
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#6B7280",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                backgroundColor: "#F9FAFB",
                                borderBottom: "2px solid #E5E7EB",
                              }}
                            >
                              Actions
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {membershipData.membership_history.map(
                            (history, index) => (
                              <TableRow
                                key={index}
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "#F9FAFB",
                                  },
                                }}
                              >
                                <TableCell
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    color: "#1F1F1F",
                                    borderBottom: "1px solid #E5E7EB",
                                  }}
                                >
                                  {history.renewal_label}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    color: "#1F1F1F",
                                    borderBottom: "1px solid #E5E7EB",
                                  }}
                                >
                                  {history.membership_name}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    color: "#1F1F1F",
                                    borderBottom: "1px solid #E5E7EB",
                                  }}
                                >
                                  {history.signup_display}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    color: "#1F1F1F",
                                    borderBottom: "1px solid #E5E7EB",
                                  }}
                                >
                                  {history.renewal_display || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    color: "#1F1F1F",
                                    borderBottom: "1px solid #E5E7EB",
                                  }}
                                >
                                  {history.valid_till_display}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    borderBottom: "1px solid #E5E7EB",
                                  }}
                                >
                                  <Chip
                                    label={history.status}
                                    size="small"
                                    sx={{
                                      fontSize: "11px",
                                      height: "24px",
                                      fontWeight: 500,
                                      backgroundColor:
                                        history.status === "Current"
                                          ? "#DCFCE7"
                                          : history.status === "Renewed"
                                          ? "#E0E7FF"
                                          : "#FEE2E2",
                                      color:
                                        history.status === "Current"
                                          ? "#15803D"
                                          : history.status === "Renewed"
                                          ? "#3730A3"
                                          : "#991B1B",
                                      border: "none",
                                    }}
                                  />
                                </TableCell>
                                <TableCell
                                  sx={{
                                    borderBottom: "1px solid #E5E7EB",
                                  }}
                                >
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      handleViewFeatures(history.features)
                                    }
                                    sx={{
                                      color: "#6B7280",
                                      "&:hover": {
                                        backgroundColor: "#F3F4F6",
                                        color: "#374151",
                                      },
                                    }}
                                  >
                                    <Button variant="outlined" color="primary" size="small" sx={{ textTransform: 'none', fontSize: 13, borderColor: '#3B82F6', color: '#3B82F6' }}>
                                      <VisibilityIcon
                                        sx={{ fontSize: 18, mr: 0.5}}
                                      />
                                      View
                                    </Button>
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            )
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                )}
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "300px",
              }}
            >
              <Typography
                color="text.secondary"
                fontSize="14px"
                sx={{ fontWeight: 400 }}
              >
                No membership details available
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Features Dialog */}
      <Dialog
        open={featuresDialogOpen}
        onClose={handleCloseFeaturesDialog}
        maxWidth={false}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            maxHeight: "85vh",
            width: "800px",
            maxWidth: "90vw",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E5E7EB",
            pb: 2,
            pt: 2.5,
            px: 3,
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              color: "#1F1F1F",
            }}
          >
            Membership Features
          </Typography>
          <IconButton
            onClick={handleCloseFeaturesDialog}
            size="small"
            sx={{
              color: "#6B7280",
              "&:hover": {
                backgroundColor: "#F3F4F6",
              },
            }}
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          {selectedFeatures && selectedFeatures.length > 0 ? (
            <Paper
              elevation={0}
              sx={{
                border: "1px solid #E5E7EB",
                borderRadius: "6px",
                overflow: "hidden",
                mt: 2,
              }}
            >
              <TableContainer>
                <Table
                  sx={{
                    border: "1px solid #E5E7EB",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontSize: "12px",
                          fontWeight: 600,
                          color: "#6B7280",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          backgroundColor: "#F9FAFB",
                          borderBottom: "2px solid #E5E7EB",
                          borderRight: "1px solid #E5E7EB",
                          padding: "16px 20px",
                        }}
                      >
                        Feature Name
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "12px",
                          fontWeight: 600,
                          color: "#6B7280",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          backgroundColor: "#F9FAFB",
                          borderBottom: "2px solid #E5E7EB",
                          borderRight: "1px solid #E5E7EB",
                          padding: "16px 20px",
                        }}
                      >
                        Type
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "12px",
                          fontWeight: 600,
                          color: "#6B7280",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          backgroundColor: "#F9FAFB",
                          borderBottom: "2px solid #E5E7EB",
                          padding: "16px 20px",
                        }}
                      >
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedFeatures.map((feature, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:hover": {
                            backgroundColor: "#F9FAFB",
                          },
                        }}
                      >
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#1F1F1F",
                            borderBottom: "1px solid #E5E7EB",
                            borderRight: "1px solid #E5E7EB",
                            padding: "16px 20px",
                          }}
                        >
                          {feature.feature_name}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#1F1F1F",
                            borderBottom: "1px solid #E5E7EB",
                            borderRight: "1px solid #E5E7EB",
                            padding: "16px 20px",
                          }}
                        >
                          {feature.type}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#1F1F1F",
                            borderBottom: "1px solid #E5E7EB",
                            padding: "16px 20px",
                          }}
                        >
                          {renderFeatureValue(feature)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "200px",
              }}
            >
              <Typography
                color="text.secondary"
                fontSize="14px"
                sx={{ fontWeight: 400 }}
              >
                No features available
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ViewMembershipModal;
